import { gql } from '@apollo/client';

export const SAMPLE = gql`
    query Sample($sampleGuid: ID!) {
        sample(sampleGuid: $sampleGuid) {
            guid
            name
            bpm
            duration
            pack {
                artworkUrl
                guid
                name
                slug
                artist {
                    guid
                    slug
                    name
                }
                label {
                    guid
                    slug
                }
                mainGenre {
                    code
                }
                genres {
                    code
                }
                sfxs {
                    code
                }
            }
            sampleType
            key {
                code
                root
                quality
            }
            isFavorited
            isDownloaded
            isRecommendationFiller
            waveformUrl
            credits
            instruments {
                code
                isFamily
                subInstruments {
                    code
                }
            }
            tags {
                code
            }
            sfxs {
                code
                subSfxs {
                    code
                }
            }
            sampleState
        }
    }
`;

export const SAMPLE_IS_DOWNLOADED_STATE = gql`
    query SampleIsDownloaded($guid: ID!) {
        sample(sampleGuid: $guid) {
            guid
            isDownloaded
        }
    }
`;

export const PaginatedSamplesQuery = gql`
    query PaginatedSamples(
        $take: Int = 1
        $page: Int = 0
        $query: String
        $offset: Int
    ) {
        paginatedSamples(
            take: $take
            page: $page
            query: $query
            offset: $offset
        ) {
            data {
                guid
                name
                bpm
                duration
                pack {
                    artworkUrl
                    guid
                    name
                    slug
                    artist {
                        guid
                        slug
                        name
                    }
                    label {
                        guid
                        slug
                    }
                    mainGenre {
                        code
                    }
                    genres {
                        code
                    }
                    sfxs {
                        code
                    }
                }
                sampleType
                key {
                    code
                    root
                    quality
                }
                isFavorited
                isDownloaded
                isRecommendationFiller
                waveformUrl
                credits
                instruments {
                    code
                    isFamily
                    subInstruments {
                        code
                    }
                }
                tags {
                    code
                }
                sfxs {
                    code
                    subSfxs {
                        code
                    }
                }
            }
            meta {
                totalRecords
                totalSampleRecords
                totalPackRecords
                filters {
                    sampleTypeFilters {
                        name
                        value
                    }
                    instrumentFilters {
                        name
                        value
                    }
                    genreFilters {
                        name
                        value
                    }
                    sfxFilters {
                        name
                        value
                    }
                    tagFilters {
                        name
                        value
                    }
                }
            }
            next {
                skip
            }
        }
    }
`;

export const PaginatedDownloadedSamplesQuery = gql`
    query PaginatedDownloadedSamples(
        $take: Int = 1
        $page: Int = 0
        $query: String
        $offset: Int
    ) {
        paginatedDownloadedSamples(
            take: $take
            page: $page
            query: $query
            offset: $offset
        ) {
            data {
                guid
                name
                bpm
                duration
                pack {
                    artworkUrl
                    guid
                    name
                    slug
                    artist {
                        guid
                        slug
                    }
                    label {
                        guid
                        slug
                    }
                    mainGenre {
                        code
                    }
                    genres {
                        code
                    }
                    sfxs {
                        code
                    }
                    packState
                }
                sampleType
                key {
                    code
                    root
                    quality
                }
                isFavorited
                isDownloaded
                isRecommendationFiller
                waveformUrl
                credits
                instruments {
                    code
                    isFamily
                    subInstruments {
                        code
                    }
                }
                sfxs {
                    code
                    subSfxs {
                        code
                    }
                }
                sampleState
            }
            meta {
                totalRecords
                totalSampleRecords
                totalPackRecords
                filters {
                    sampleTypeFilters {
                        name
                        value
                    }
                    instrumentFilters {
                        name
                        value
                    }
                    genreFilters {
                        name
                        value
                    }
                    sfxFilters {
                        name
                        value
                    }
                    tagFilters {
                        name
                        value
                    }
                }
            }

            next {
                skip
            }
        }
    }
`;

export const PaginatedFavoritedSamplesQuery = gql`
    query PaginatedFavoritedSamples(
        $take: Int = 1
        $page: Int = 0
        $query: String
        $offset: Int
    ) {
        paginatedFavoritedSamples(
            take: $take
            page: $page
            query: $query
            offset: $offset
        ) {
            data {
                guid
                name
                bpm
                duration
                pack {
                    artworkUrl
                    guid
                    name
                    slug
                    artist {
                        guid
                        slug
                    }
                    label {
                        guid
                        slug
                    }
                    mainGenre {
                        code
                    }
                    genres {
                        code
                    }
                    sfxs {
                        code
                    }
                }
                sampleType
                key {
                    code
                    root
                    quality
                }
                isFavorited
                isDownloaded
                isRecommendationFiller
                waveformUrl
                credits
                instruments {
                    code
                    isFamily
                    subInstruments {
                        code
                    }
                }
                tags {
                    code
                }
                sfxs {
                    code
                    subSfxs {
                        code
                    }
                }
            }
            meta {
                totalRecords
                totalSampleRecords
                totalPackRecords
                filters {
                    sampleTypeFilters {
                        name
                        value
                    }
                    instrumentFilters {
                        name
                        value
                    }
                    genreFilters {
                        name
                        value
                    }
                    sfxFilters {
                        name
                        value
                    }
                    tagFilters {
                        name
                        value
                    }
                }
            }

            next {
                skip
            }
        }
    }
`;

export const PAGINATED_RECOMMENDED_SAMPLES_QUERY = gql`
    query PaginatedRecommendedSamples(
        $sampleGuid: ID!
        $take: Int = 1
        $page: Int = 0
        $query: String
        $offset: Int
    ) {
        paginatedRecommendedSamples(
            sampleGuid: $sampleGuid
            take: $take
            page: $page
            query: $query
            offset: $offset
        ) {
            data {
                guid
                name
                bpm
                duration
                pack {
                    artworkUrl
                    slug
                    guid
                    name
                    artist {
                        guid
                        slug
                    }
                    label {
                        guid
                        slug
                    }
                    mainGenre {
                        code
                    }
                    genres {
                        code
                    }
                    sfxs {
                        code
                    }
                }
                sampleType
                key {
                    code
                    root
                    quality
                }
                isFavorited
                isDownloaded
                isRecommendationFiller
                waveformUrl
                credits
                instruments {
                    code
                    isFamily
                    subInstruments {
                        code
                    }
                }
                tags {
                    code
                }
                sfxs {
                    code
                    subSfxs {
                        code
                    }
                }
            }
            meta {
                totalRecords
                totalSampleRecords
                totalPackRecords
                filters {
                    sampleTypeFilters {
                        name
                        value
                    }
                    instrumentFilters {
                        name
                        value
                    }
                    genreFilters {
                        name
                        value
                    }
                    sfxFilters {
                        name
                        value
                    }
                    tagFilters {
                        name
                        value
                    }
                }
            }
            next {
                skip
            }
        }
    }
`;

export const UPDATE_SAMPLE_FAVORITED_STATE = gql`
    mutation UpdateSampleFavoritedState($sample: SampleFavoritedInput!) {
        updateSampleFavoritedState(sample: $sample) {
            guid
            isFavorited
        }
    }
`;

export const SAMPLE_STREAM_QUERY = gql`
    query SampleStream($sampleGuid: ID!) {
        sampleStream(sampleGuid: $sampleGuid) {
            url
        }
    }
`;

// Un-used query needed for useLazyQuery, we should refacto query with useQuery skip and fetch instead https://mixgenius.atlassian.net/browse/SP-10379
export const CUSTOM_STREAM_QUERY = gql`
    query SampleStream($sampleGuid: ID!) {
        sampleStream(sampleGuid: $sampleGuid) {
            url
        }
    }
`;
